<template lang="pug">
el-container
  el-header.header(height="60px")
    el-menu(
      :default-active="activeIndex"
      mode="horizontal"
      background-color="#000000"
      text-color="#FFF"
      active-text-color="#3789cb"
      :router="true"
    )
      el-menu-item(@click.native="goToCloud")
        img.header-logo-img(alt="SatMetaInfo" :src="logo")
        //- span.header-logo 卫星及载荷检索
        //- el-menu-item.nav-logo(index="/" :route="{ name: 'home' }")
        //-     span 卫星及载荷检索
      el-menu-item.nav-logo(index="/" :route="{ name: 'home' }" style="border-bottom:none;")
        span.header-logo 卫星及载荷检索
      el-menu-item.nav-font(onclick="window.open('https://apps.vsat.cloud/apps/launch')" style="float:right;") 发射事件
      el-menu-item.nav-font(index="/launch" :route="{ name: 'launch' }") 发射简史
      el-menu-item.nav-font(index="/instrument" :route="{ name: 'instrument' }") 载荷
      el-menu-item.nav-font(index="/satellite" :route="{ name: 'satellite' }") 卫星
      //- el-menu-item.nav-font(index="/data-vendor" :route="{ name: 'data-vendor' }") 数据供应商
      el-menu-item.nav-list
        el-dropdown(trigger="click")
          span.el-dropdown-link
            img.header-logo-img(alt="NavListGuide" src="img/icons/list.png")
          el-dropdown-menu(slot="dropdown")
            el-dropdown-item(@click.native="jumpTo('/satellite')") 卫星
            el-dropdown-item(@click.native="jumpTo('/instrument')") 载荷
  el-main
    router-view
</template>

<script>
import { listApp, getUserinfo } from "@/services";
export default {
  name: "app",
  data() {
    return {
      activeIndex: "/",
      logo: "img/vsatcloud.png"
    };
  },
  methods: {
    jumpTo(url) {
      this.$router.push({ path: url });
    },
    goToCloud() {
      window.open("https://apps.vsat.cloud/applist", "_self");
    },
    // 是否有自定义logo
    async fetchLogo() {
      let appEnabled = false;
      const res1 = await getUserinfo();
      const res2 = await listApp();
      if (res2.code === 0) {
        // this.$store.commit("SET_APP_LIST", res.data);
        res2.data.items.forEach(item => {
          if (item.app_name === "satmetapi") {
            appEnabled = true;
          }
        });
      }
      if (appEnabled && res1.code === 0 && res1.data.company.logo !== null) {
        this.logo = res1.data.company.logo;
      }
    }
  },
  mounted() {
    this.fetchLogo();
    this.activeIndex = this.$route.meta.activeIndex
      ? this.$route.meta.activeIndex
      : this.$route.matched[1].path;
  }
};
</script>

<style lang="stylus" scoped>
.header {
  background: #ffffff;
  color: #333;
  text-align: center;
  padding: 0px;
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  z-index: 999999;
}

.header-logo-img {
  width: 35px;
}

.header-logo {
  margin-left: 5px;
  font-size: 32px;
  font-family: Futura;
  font-weight: bold;
  color: #76BBE4;
}

.el-main {
  padding: 60px 0 0;
}

.el-menu.el-menu--horizontal {
  border-bottom: none;
}

.el-menu-item {
  &:nth-last-child(2) {
    float: right;
  }

  &:nth-last-child(3) {
    float: right;
  }

  &:nth-last-child(4) {
    float: right;
  }

  &:last-child {
    display: none;
  }
}

.nav-font {
  font-size: large;
  font-weight: bolder;
}

.nav-list {
  display: none;
}

@media only screen and (max-width: 540px) {
  .nav-font {
    display: none;
  }

  .nav-list {
    display: inline;
  }

  .el-menu-item {
    padding: 0 10px;

    &:nth-last-child(2) {
      float: left;
    }

    &:last-child {
      display: inline;
      float: right;
    }
  }

  .header {
    background: #ffffff;
    color: #333;
    text-align: center;
    line-height: 60px;
    padding: 0px;
  }

  .el-main {
    padding: 60px 0 0;
  }

  .el-dropdown-menu {
    margin: 0px 0px;
    // right: 0px;
  }
}
</style>
